import axios from './axios';

export default {
  get: () => axios.get('/datacenter'),
  pdfPresentationDatacenter: (datacenterId) => axios.get(`/datacenters/${datacenterId}/pdf_presentation_url`),
  videoPresentationDatacenter: (datacenterId) => axios.get(`/datacenters/${datacenterId}/video_presentation_url`),
};
